import React, { useEffect, useState } from 'react';
import { adminApi } from '../../config/axios';
import { useGlobal } from '../../contexts/GlobalContext';

const TOGGLES = [
  ['alwaysStart', 'Always on', 'Keep the player running (restart it if it stops).'],
  ['startAtBoot', 'Start on boot', 'Launch the player automatically when the device boots.'],
  ['lockOnTurnOff', 'Lock on turn-off', 'Lock the device when the screen is turned off.'],
];

/** Install-team settings. The customer device page no longer shows these three. */
export default function DeviceSettingsCard({ deviceId, settings }) {
  const { showToast } = useGlobal();
  const [vals, setVals] = useState({ alwaysStart: false, startAtBoot: false, lockOnTurnOff: false });
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    const s = settings && typeof settings === 'object' ? settings : {};
    setVals({ alwaysStart: !!s.alwaysStart, startAtBoot: !!s.startAtBoot, lockOnTurnOff: !!s.lockOnTurnOff });
  }, [settings]);
  const save = async () => {
    setSaving(true);
    try {
      await adminApi.post(`/device/${deviceId}/update/device-settings`, vals);
      showToast('success', 'Saved', 'Device settings updated and pushed to the device.');
    } catch (err) {
      showToast('error', 'Failed', err?.response?.data?.message ?? 'Could not update device settings.');
    } finally { setSaving(false); }
  };
  return (
    <div className="card-padded flex flex-col gap-3" data-testid="device-settings-card">
      <h3 className="section-title">Device settings (install team)</h3>
      <p className="text-xs text-text-muted">Not shown to the customer. Saved settings are pushed to the player immediately.</p>
      {TOGGLES.map(([k, label, hint]) => (
        <label key={k} className="flex items-start justify-between gap-3 cursor-pointer">
          <span><span className="text-sm text-text-main font-medium">{label}</span><span className="block text-xs text-text-muted">{hint}</span></span>
          <input type="checkbox" checked={vals[k]} onChange={(e) => setVals((v) => ({ ...v, [k]: e.target.checked }))} data-testid={`toggle-${k}`} className="mt-1" />
        </label>
      ))}
      <div><button onClick={save} disabled={saving} className="btn-primary text-xs" data-testid="save-device-settings">{saving ? 'Saving…' : 'Save settings'}</button></div>
    </div>
  );
}
